import React from "react";
import noticeTypeToRussian from "../../../../constants/noticeTypeToRussian";
import DefaultDatePicker from "./DefaultDatePicker";
import NoticeText from "./NoticeText";

const SMSSettings = ({ templates }) => {
	return (
		<div style={{ position: "relative" }}>
			<span className="type_name">{noticeTypeToRussian.SMS}</span>
			<DefaultDatePicker type={"SMS"} />
			<NoticeText templates={templates} fieldKey="SmsTemplateId" />
		</div>
	);
};

export default SMSSettings;
